import script from "./SellerCate.vue?vue&type=script&lang=ts&setup=true"
export * from "./SellerCate.vue?vue&type=script&lang=ts&setup=true"

import "./SellerCate.vue?vue&type=style&index=0&id=80fe9b80&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80fe9b80"]])

export default __exports__